const getAccountName = ({ account, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return account ? `${account['Last Name']}, ${account['First Name']}`.toUpperCase() : '';
};

export default getAccountName;



// WEBPACK FOOTER //
// ./src/utils/print/getAccountName.js